/**
 * Иторум API для портала
 * Спецификация Open API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { ActionTemplateIdCompetenciesBody } from '../model/actionTemplateIdCompetenciesBody';
import { InlineResponse20042 } from '../model/inlineResponse20042';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class ActionTemplateCompetenciesService {
  protected basePath = 'https://dev.itorummr.com';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Get action template competencies relation
   *
   * @param actionTemplateId Action template id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiActionTemplateActionTemplateIdCompetenciesGet(
    actionTemplateId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<InlineResponse20042>;
  public apiActionTemplateActionTemplateIdCompetenciesGet(
    actionTemplateId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<InlineResponse20042>>;
  public apiActionTemplateActionTemplateIdCompetenciesGet(
    actionTemplateId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<InlineResponse20042>>;
  public apiActionTemplateActionTemplateIdCompetenciesGet(
    actionTemplateId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (actionTemplateId === null || actionTemplateId === undefined) {
      throw new Error(
        'Required parameter actionTemplateId was null or undefined when calling apiActionTemplateActionTemplateIdCompetenciesGet.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InlineResponse20042>(
      'get',
      `${this.basePath}/api/action-template/${encodeURIComponent(
        String(actionTemplateId)
      )}/competencies`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Create action template competencies relation
   *
   * @param actionTemplateId Action template id
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiActionTemplateActionTemplateIdCompetenciesPost(
    actionTemplateId: number,
    body?: ActionTemplateIdCompetenciesBody,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public apiActionTemplateActionTemplateIdCompetenciesPost(
    actionTemplateId: number,
    body?: ActionTemplateIdCompetenciesBody,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public apiActionTemplateActionTemplateIdCompetenciesPost(
    actionTemplateId: number,
    body?: ActionTemplateIdCompetenciesBody,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public apiActionTemplateActionTemplateIdCompetenciesPost(
    actionTemplateId: number,
    body?: ActionTemplateIdCompetenciesBody,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (actionTemplateId === null || actionTemplateId === undefined) {
      throw new Error(
        'Required parameter actionTemplateId was null or undefined when calling apiActionTemplateActionTemplateIdCompetenciesPost.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/api/action-template/${encodeURIComponent(
        String(actionTemplateId)
      )}/competencies`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
